jQuery(function ($) {

	//var mediumwidth = 768;
	var maxcontentwidth = 1400;

	var titlecolor = $("#page-title").css("color");
	if (titlecolor != "rgb(255, 255, 255)") {
		$("#page-title").css("text-shadow", "none");
	}

    $(window).load(function() {
        $("html").removeClass("no-js"); // removes no-js class when js executes
        $("body").removeClass("preload"); // prevents flash of un-transitioned elements with css transitions
        $("#wrapper").removeClass("load-with-js"); // prevents flash of unstyled content and provides a fade on load effect with css

		equalHeight();
		respSquare();

        /*****STICKY FOOTER****
        var footer = $("#footer");
        var pos = footer.position();
        var height = $(window).height();
        height = height - pos.top;
        height = height - footer.outerHeight();
        if (height > 0) {
            footer.css({
                'margin-top': height + 'px'
            });
        }*/

        $(".off-canvas nav a, .off-canvas input, .off-canvas button, a.post-featured-image").attr("tabindex", "-1");
        $(".off-canvas").find(".logo").remove();

    });

	$(document).ready(function() {
		/*****REMOVE PARENT P TAG FROM CTA CLASS*****/
		var cta = $(".cta");
		if ( cta.parent().is( "p" ) ) {
			cta.unwrap();
		}

	});

    $(".dropdown-pane-close").on("keypress", function() {
       $(this).parent().removeClass("is-open");
    });

	/***** RESPONSIVE SQUARE/CIRCLE SCRIPT *****/
	function respSquare() {
		$('.circle').each(function() {
			var cirwidth = $(this).width();
			$(this).height(cirwidth);
		});
	}

	/***** EQUAL HEIGHT ELEMENTS *****/
	function equalHeight() {
		window.windowWidth = $(window).width();
		$('.equalheight-parent').each(function(){
			if (Foundation.MediaQuery.atLeast('medium')){
				//var highest = 0;
				var hi = 0;
				var i = 1;
				$(this).find('.equalheight').css('height', '').each(function(){
					var h = $(this).outerHeight();
					//var oh = $(this).outerHeight();
					var mh = $(this).css("min-height").replace(/[^-\d\.]/g, '');
					var ch = $(this).find(".flexi_c_text").outerHeight();
					var vh = $(this).find(".flexi_vid").outerHeight();
					if(vh > h || vh > ch || vh > mh) { h = vh; }
					if(ch > h || ch > mh || ch > vh) { h = ch; }
					if(mh > h || mh > ch || mh > vh){ h = mh; }
					if(h > hi){
					   hi = h;
					   //highest = $(this).height();
					}
					i++;
				});
				$(this).find(".equalheight").css('height', hi);
			}
			else {
				$(this).find('.equalheight').css("height", "auto");
			}
		});
	}

    // Finds flexible column widths for responsive layouts
	function flexi_columns() {
		window.windowWidth = $(window).width();
		$('.flexi_row').each(function(){
			if (windowWidth > maxcontentwidth*1.285 ){
				var midRowWidth = $(this).find('.flexi_mid').outerWidth();
				var mid2RowWidth = $(this).find('.flexi_mid2').outerWidth();
				var midrows = midRowWidth + mid2RowWidth;
				var siderows = (windowWidth-midRowWidth)/2;
				$(this).find('.flexi_three.flexi_mid').css("width", Math.floor(midRowWidth));
				$(this).find('.flexi_three.flexi_left').css("width", siderows);
				$(this).find('.flexi_three.flexi_right').css("width", siderows);
				$(this).find('.flexi_four.flexi_left').css("width", (windowWidth-midrows)/2);
				$(this).find('.flexi_four.flexi_right').css("width", (windowWidth-midrows)/2);
			}
			else if (Foundation.MediaQuery.atLeast('medium')) {
				$(this).find('.flexi_three.flexi_mid').css("width", "33.333%");
				$(this).find('.flexi_three.flexi_left').css("width", "33.333%");
				$(this).find('.flexi_three.flexi_right').css("width", "33.333%");
				$(this).find('.flexi_four.flexi_left').css("width", "25%");
				$(this).find('.flexi_four.flexi_right').css("width", "25%");
			}
			else {
				$(this).find('.flexi_three.flexi_mid').css("width", "100%");
				$(this).find('.flexi_three.flexi_left').css("width", "100%");
				$(this).find('.flexi_three.flexi_right').css("width", "100%");
				$(this).find('.flexi_four.flexi_left').css("width", "100%");
				$(this).find('.flexi_four.flexi_right').css("width", "100%");
			}
		});
	}

    /***** ADAPT ELEMTENTS ON RESIZE & LOAD *****/
    function adaptPageElementsOnResizeAndReady() {

		var windowHeight = $(window).height();
		var headerheight = $("#header").innerHeight();
		var windowwidth = $( window ).width();

		// Main padding-top for header
		$("main").css("padding-top", headerheight);

		// Page Header Min-Height
		var page_header = $("#page_header .row");
        var page_header_text = $("#header_text");
        var page_header_content_height = parseInt(page_header_text.innerHeight());
        var page_header_content_top = 0;
		if (Foundation.MediaQuery.atLeast('medium') && document.getElementById("page_header")) {
            var row_padding_top = parseInt(page_header.css("padding-top"));
            var row_padding_bottom = parseInt(page_header.css("padding-bottom"));
			var page_header_content_position = $("#header_text").position();
            if (page_header_content_position) { page_header_content_top = page_header_content_position.top; }
            var page_header_content_margintop = parseInt($("#header_text").css("margin-top"));
            page_header_content_top = page_header_content_margintop+page_header_content_top+row_padding_top+row_padding_bottom;
        }
		if(page_header_content_top > "0") {
			page_header_min_height = page_header_content_top + page_header_content_height + 'px';
		}
        else {
			page_header_min_height = page_header_content_height + 'px';
		}
		page_header.css("min-height", page_header_min_height);

		$('.home #page_header .row').css('height', windowHeight-headerheight);

		// Home Service Tabs
		var maxTabHeight = -1;
		$('.service-panel').each(function() {
			tabheadHeight = $(this).find("h2").height();
			tabcontentHeight = $(this).find(".tab_content").height();
			tabHeight = tabheadHeight + tabcontentHeight + 310;
			maxTabHeight = maxTabHeight > tabHeight ? maxTabHeight : tabHeight;
		});
		$('.service-tabs.tabs-content').outerHeight(maxTabHeight);
		$('.service-panel').outerHeight(maxTabHeight);

		// Home Post Feed
		var maxPostHeight = -1;
		$('.home .post_item').each(function() {
			postheadHeight = $(this).find("h3").outerHeight();
			postcontentHeight = 0;
			$(this).find("p").each(function() {
				postcontentHeight += $(this).outerHeight();
			});
			postHeight = postheadHeight + postcontentHeight + 109;
			maxPostHeight = maxPostHeight > postHeight ? maxPostHeight : postHeight;
		});
		$('.home .post_item').outerHeight(maxPostHeight);

		// Page Footer Min-Height
		var page_footer = $("#page_footer .row");
        var page_footer_text = $("#footer_text");
        var page_footer_content_height = parseInt(page_footer_text.innerHeight());
        var page_footer_content_top = 0;
        if (Foundation.MediaQuery.atLeast('medium') && document.getElementById("page_footer")) {
            var frow_padding_top = parseInt(page_footer.css("padding-top"));
            var frow_padding_bottom = parseInt(page_footer.css("padding-bottom"));
			var page_footer_content_position = $("#footer_text").position();
            if (page_footer_content_position) { page_footer_content_top = page_footer_content_position.top; }
            var page_footer_content_margintop = parseInt($("#footer_text").css("margin-top"));
            page_footer_content_top = page_footer_content_margintop+page_footer_content_top+frow_padding_top+frow_padding_bottom;
        }
		if(page_footer_content_top > "0") { page_footer_min_height = page_footer_content_top + page_footer_content_height + 'px'; }
        else { page_footer_min_height = page_footer_content_height + 'px'; }
        page_footer.css("min-height", page_footer_min_height);
        $("#page_footer").css("min-height", page_footer_min_height);

		// Make elements equal height on resize
        equalHeight();
		respSquare();
		flexi_columns();

        // Responsive Tabindex

        if ($(".hide-for-large").css("display") == "none") {
            $(".hide-for-large").children().find("a").attr("tabindex", "-1");
        }
        else {
            $(".hide-for-large").children().find("a").attr("tabindex", "0");
        }

        if ($(".hide-for-small").css("display") == "none") {
            $(".hide-for-small").children().find("a").attr("tabindex", "-1");
        }
        else {
            $(".hide-for-small").children().find("a").attr("tabindex", "0");
        }

        var menu = $(".off-canvas");
        var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.attributeName === "class") {
              var attributeValue = $(mutation.target).prop(mutation.attributeName);
              if (attributeValue.indexOf(" is-open") >= 0) {
                $(mutation.target).children().find("a").attr("tabindex", "0");
              }
              else {
                $(mutation.target).children().find("a").attr("tabindex", "-1");
              }
            }
          });
        });
        observer.observe(menu[0], {
          attributes: true
        });


	}
	$(document).on("ready", adaptPageElementsOnResizeAndReady);
	$(window).on("resize", adaptPageElementsOnResizeAndReady);

    /***** ADD SCREENREADER TEXT TO target="_blank" LINKS *****/
    $('a').each(function() {

        var link = $(this);
        var linkText = $(this).text();

        if (!link.attr('href')) {
            return; // if href if not set
        }

        if (link.attr('aria-label')) {
            return; // if a custom aria label is already set
        }

        if ( link.attr('target') == '_blank' ) {
            // add aria label set to the original link text + append translatable external link message (set in footer.php)
            link.attr('aria-label', linkText + ', ' + ENV_VARS.extLinkMessage);
        }

        if ( link.hasClass('scrollto')) {
            // add aria label set to the original link text + append translatable scroll to link message (set in footer.php)
            link.attr('aria-label', linkText + ', ' + ENV_VARS.scrollToLinkMessage);
        }

    });

    /***** SIDEBAR SKIP TO LINK HREF *****/
    // Find any sidebars that are loaded before #inner-content + update their skip link href to  #inner-content
    $('#inner-content').prev('#sidebar').prev('.skip-link').attr('href', '#inner-content');

	/***** SCROLLTO ANIMATION with CLASS *****/
	$('a.scrollto').on("click keypress", function() {
        if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname && !$(this).parent().hasClass('is-accordion-submenu-parent')) {
          var target = $(this.hash);
          if (target.length) {
            $('html, body').animate({
              scrollTop: target.offset().top
            }, 1000);
            return false;
          }
        }
    });

    /***** FADE IN ON SCROLL with CLASS *****/

	$(".fadein").css("opacity", 0);
	var fadeins = $('.fadein').waypoint(function(direction) {
	  $(this.element).toggleClass("show");
	}, {
	  offset: '85%'
	});

	$(".fa-fadein").css("opacity", 0);
	var fafadeins = $('.fa-fadein').waypoint(function(direction) {
	  $(this.element).toggleClass("show");
	}, {
	  offset: '85%'
	});


    /***** RESPONSIVE BACKGROUND IMAGE SOLUTION FOR SRCSET *****/
    /*$(".imgcover").each(function(){
        if ($(this).css('object-fit') === null) {
            var backgroundImage = $(this).attr("src");
            $(this).css("background-image", "url("+backgroundImage+")");
            $(this).attr("src", "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7");
            $(this).attr("srcset", "");
        }
    });*/

    /***** RESPONSIVE TABLES *****/
    // based on https://sitesforprofit.com/responsive-tables-in-wordpress
    (function () {
        var headertext = [];
        var headers = document.querySelectorAll("thead");
        var tablebody = document.querySelectorAll("tbody");

        for(var i = 0; i < headers.length; i++) {
            headertext[i]=[];
            for (var j = 0, headrow; headrow = headers[i].rows[0].cells[j]; j++) {
              var current = headrow;
              headertext[i].push(current.textContent.replace(/\r?\n|\r/,""));
              }
        }

        if (headers.length > 0) {
            for (var h = 0, tbody; tbody = tablebody[h]; h++) {
                for (var i = 0, row; row = tbody.rows[i]; i++) {
                  for (var j = 0, col; col = row.cells[j]; j++) {
                    col.setAttribute("data-th", headertext[h][j]);
                  }
                }
            }
        }
    } ());


    /***** HAVE CLASS? *****/
    function hasClass(element, cls) {
        return (' ' + element.className + ' ').indexOf(' ' + cls + ' ') > -1;
    }

	/***** HOMEPAGE TAB NAVIGATION *****/
	$("#prev-tab").on("click keypress", function() {

        $( "#home-tabs" ).find( "li.is-active" ).each(function() {
            if ($(this).is(":first-child")) {
                $(this).removeClass("is-active").each(function() {$(this).find("a").attr("aria-selected","false"); });
                $( "#home-tabs" ).find( "li:last-child").addClass("is-active").each(function() { $(this).find("a").attr("aria-selected","true"); });
            }
            else {
                $(this).removeClass("is-active").each(function() {$(this).find("a").attr("aria-selected","false"); }).prev().addClass("is-active").each(function() { $(this).find("a").attr("aria-selected","true"); });
            }
        });

        $( ".tabs-content" ).find( "div.is-active" ).each(function() {
            if ($(this).is(":first-child")) {
                $(this).removeClass("is-active").attr("aria-hidden","true");
                $( ".tabs-content" ).find( "div:last-child").addClass("is-active").attr("aria-hidden","false");
            }
            else {
                $(this).removeClass("is-active").attr("aria-hidden","true").prev().addClass("is-active").attr("aria-hidden","false");
            }
        });

	});
    $("#next-tab").on("click keypress", function() {

        $( "#home-tabs" ).find( "li.is-active" ).each(function() {
            if ($(this).is(":last-child")) {
                $(this).removeClass("is-active").each(function() {$(this).find("a").attr("aria-selected","false"); });
                $( "#home-tabs" ).find( "li:first-child").addClass("is-active").each(function() { $(this).find("a").attr("aria-selected","true"); });
            }
            else {
                $(this).removeClass("is-active").each(function() {$(this).find("a").attr("aria-selected","false"); }).next().addClass("is-active").each(function() { $(this).find("a").attr("aria-selected","true"); });
            }
        });

        $( ".tabs-content" ).find( "div.is-active" ).each(function() {
            if ($(this).is(":last-child")) {
                $(this).removeClass("is-active").attr("aria-hidden","true");
                $( ".tabs-content" ).find( "div:first-child").addClass("is-active").attr("aria-hidden","false");
            }
            else {
                $(this).removeClass("is-active").attr("aria-hidden","true").next().addClass("is-active").attr("aria-hidden","false");
            }
        });

    });

    /***** GO TO CATEGORY ARCHIVE BASED ON SELECT *****/
    var siteurl = ENV_VARS.siteurl;
	var postpage = ENV_VARS.postpage;
	var resourcepage = ENV_VARS.resourcepage;
	var staffpage = ENV_VARS.staffpage;
    var dropdown = document.getElementById("cat_select");
    var cat_slug = 'category';
	var page_slug = "?p="+postpage;
    if (dropdown) {
        if (hasClass(dropdown, 'resource_cat')) { cat_slug = "resource-category"; page_slug = "?p="+resourcepage; }
        if (hasClass(dropdown, 'staff_cat')) { cat_slug = "staff-category"; page_slug = "?p="+staffpage; }
        var onCatChange = function () {
            if ( dropdown.options[dropdown.selectedIndex].value ) {
				if ( dropdown.options[dropdown.selectedIndex].value === "all" ) {
					location.href = siteurl+"/"+page_slug;
				}
                else { location.href = siteurl+"/"+cat_slug+"/"+dropdown.options[dropdown.selectedIndex].value; }
            }
        };
        dropdown.onchange = onCatChange;
    }

	/***** MAX ITEM LIST *****/
	$(document).ready(function() {
		$('[id^=categories] ul').hideMaxListItems({
			'max':6,
			'speed':2000,
			'moreText':'SHOW MORE CATEGORIES <i class="fa fa-plus-circle" aria-hidden="true"></i>',
			'lessText':'SHOW LESS <i class="fa fa-minus-circle" aria-hidden="true"></i>'
		});
	});


});